import { css } from '@emotion/core'
import styled from '@emotion/styled'

// Visually hidden element, in a way that screen readers still can read it.
export const VisuallyHidden = styled('span')(css`
  height: 0.0625rem;
  width: 0.0625rem;
  border: 0;
  clip: rect(0 0 0 0);
  margin: -0.0625rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
`)
